import React from 'react';
import { WhiteSection } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import MailListSection from './MailListSection';
import SettingSwitch from '../../components/SettingsSwitch';
import useEmailPreferencesData from './useEmailPreferencesData';
import EmailSchedule from './EmailSchedule';

const EmailPreferences = () => {
  const {
    items,
    onAddItem,
    onRemoveItem,
    onSwitchChange,
    isResourceAllocationEmailEnabled,
    resourceAllocationRecipients
  } = useEmailPreferencesData();

  return (
    <WhiteSection t={SPACES['x-medium']}>
      <Text size='large' weight={500} mb={SPACES.normal}>
        EMAIL PREFERENCES
      </Text>
      <SettingSwitch
        checked={isResourceAllocationEmailEnabled}
        onChange={onSwitchChange}
        text='Resource Allocation Digest'
        subtext='Send key insights from the Resource Allocation report'
      >
        {isResourceAllocationEmailEnabled && <EmailSchedule />}
      </SettingSwitch>
      <MailListSection
        disabled={!isResourceAllocationEmailEnabled}
        items={items}
        selectedItems={resourceAllocationRecipients}
        onAddItem={onAddItem}
        onRemoveItem={onRemoveItem}
      />
    </WhiteSection>
  );
};

export default EmailPreferences;
